// resetChildren.js
var ResetChildren = pc.createScript('resetChildren');

// initialize code called once per entity
ResetChildren.prototype.initialize = function() {
    this.positionArray = new Array(0); 
    for(i = 0; i < this.entity.children.length; i++){
        var ip = this.entity.children[i].getLocalPosition();
        var iPos = new pc.Vec3(ip.x, ip.y, ip.z);
        this.positionArray.push(iPos);
    }
};
ResetChildren.prototype.resetNodes = function(dir){
    this.entity.enabled = false;
    for(var j = 0; j < this.entity.children.length; j++){
        var pos = this.positionArray[j];
        this.entity.children[j].setLocalPosition(pos.x, pos.y, pos.z);
    }
};

// swap method called for script hot-reloading
// inherit your script state here
// ResetChildren.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

